import { FC } from 'react';
import { Stack } from '@mui/material';
import {
  InputCheck,
  InputSelect,
  InputText,
  InputTextArea,
} from '@farmshare/ui-components';
import { Trim } from '../../types';
import { ImageUploadInput } from '../builder/image-upload-input';

interface TrimRankingQuestionFormProps {
  trims?: Trim[];
  /** The capability set ID used to group uploaded images in S3. */
  capabilityId: string;
}

/**
 * Form for creating/editing Trim Ranking questions
 * Allows customers to select trim options and rank them with optional weights
 * Used with useModal pattern
 * @param props - Component props
 * @param props.trims - Available trims from capabilities
 * @param props.capabilityId - The capability set ID for S3 image grouping
 * @returns Trim ranking question form component
 */
export const TrimRankingQuestionForm: FC<TrimRankingQuestionFormProps> = ({
  trims = [],
  capabilityId,
}) => {
  const trimOptions = trims.map((trim) => ({
    value: trim.id,
    label: trim.title,
  }));

  return (
    <Stack spacing={3}>
      <InputText label="Question Title" nameOverride="title" required />
      <InputTextArea
        label="Description"
        nameOverride="description"
        rows={2}
        hint="Optional description to help customers understand their options"
      />

      <InputText
        label="Maximum Selections"
        nameOverride="maxSelections"
        type="number"
        hint="Maximum number of trim options customers can select and rank"
      />

      <InputCheck
        label="Required"
        nameOverride="required"
        hint="Whether customers must answer this question"
      />
    </Stack>
  );
};
